<div class="body-smaller text-truncate py-1">
    <mat-icon class="panel-icon mat-icon-middle" color="accent">{{message.typeIcon}}</mat-icon>
    <b><span class="cursor-pointer" (click)="navigate(message)">{{message.subject}}</span>  ({{message.sent | date:'short'}})</b> &nbsp; 
    <span [innerHTML]="message.body"></span>
</div>

<div class="panel d-none">
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon class="panel-icon" color="accent">{{message.typeIcon}}
                </mat-icon>
                <span class="date px-2 text-truncate_" title="{{message.subject}}">{{message.subject}} <span *ngIf="message.sent">&nbsp;{{message.sent | date:'short'}} &nbsp;</span></span>
            </mat-panel-title>
            <!-- <mat-panel-description></mat-panel-description> -->
        </mat-expansion-panel-header>
        <div class="content" [innerHTML]="message.body"></div>
        <div style="margin-top:10px;">
            <a mat-stroked-button color="accent" (click)="navigate(message)">{{message.linkName}}</a>
        </div>
    </mat-expansion-panel>
</div>